import type { TopologyEdge } from '@/services/observability-api';

export function BrowserActivityDetails({ edge }: { edge: TopologyEdge }) {
  const activity = edge.activity;
  const rows: Array<[string, string]> =
    edge.protocol === 'beacon'
      ? [
          ['Queued', (activity?.queued ?? 0).toFixed(0)],
          ['Rejected', (activity?.rejected ?? 0).toFixed(0)],
        ]
      : [
          ['Attempts', (activity?.attempts ?? 0).toFixed(0)],
          ['Opened', (activity?.opened ?? 0).toFixed(0)],
          ['Failures', (activity?.failures ?? 0).toFixed(0)],
          ['Completed', (activity?.closed ?? 0).toFixed(0)],
          ['Abnormal closes', (activity?.abnormal ?? 0).toFixed(0)],
          [
            'p95 setup time',
            activity?.p95SetupMs === undefined
              ? 'Not observed'
              : `${activity.p95SetupMs.toFixed(0)} ms`,
          ],
          [
            'p95 completed duration',
            activity?.p95DurationMs === undefined
              ? 'Not observed'
              : `${(activity.p95DurationMs / 1000).toFixed(1)} s`,
          ],
        ];
  return (
    <div className="mt-5 text-sm">
      {edge.trafficType === 'telemetry' && <p className="mb-3 font-semibold">Telemetry uploads</p>}
      <p className="text-neutral-500">
        {edge.protocol === 'beacon'
          ? 'Queued means accepted by the browser, not confirmed delivery.'
          : 'Lifecycle observations in this time range. Recent activity does not imply an exact active connection count.'}
      </p>
      <dl className="mt-4 grid grid-cols-2 gap-3">
        {rows.map(([label, value]) => (
          <div key={label}>
            <dt className="text-neutral-500">{label}</dt>
            <dd className="font-semibold text-neutral-900">{value}</dd>
          </div>
        ))}
        <div className="col-span-2">
          <dt className="text-neutral-500">Last observed activity</dt>
          <dd>
            {activity?.lastSeen ? new Date(activity.lastSeen).toLocaleString() : 'Not observed'}
          </dd>
        </div>
      </dl>
    </div>
  );
}
